<script>
import Endpoints from '../../../components/common/Endpoints';
import Common from '../../../components/common/Common';
import Request from '../../../components/common/Request';
import { mapActions } from 'vuex'

export default {
    init: async (payload) => {
        const el = document.body;
        el.removeAttribute("class");
        $('.modal').modal('hide');
        // $('#spinner').modal('toggle');

        

        let response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.systemUsers.getMe}`)).data;
        payload.user = response.result;
        payload.dataCompany = response.result;
        payload.user.serviceTypes = response.result.companyUser.company.typeService;
        
        if(payload.user && payload.user.companyUser && payload.user.companyUser.subtype != 'ADMIN_MASTER')
        {
            if(payload.user.isAcceptGeneralTerms == false)
            {
                $('#modalTerm').modal('toggle'); 
            }
            else
            if(payload.user.isAcceptPurchaseTerms == false)
            {
                let service = payload.user.serviceTypes[0];
                    if(service == "PART_SUPPLIER")
                    {
                        $('#modalTermParts').modal('toggle'); 
                    }
                    if(service == "CERTIFIER")
                    {
                        $('#modalTermCertifies').modal('toggle'); 
                    }
                    if(service == "SERVICE_PROVIDER")
                    {

                        $('#modalTermServices').modal('toggle'); 
                    }
            }
            if(payload.user.isAcceptGeneralTerms == true && payload.user.isAcceptPurchaseTerms == true)
            {
                const el = document.body;
                el.removeAttribute("class");
                $('.modal').modal('hide');
            }  
        }

        
        response = (await Request.do(payload, 'GET', Request.getDefaultHeader(payload), {}, `${Endpoints.companies.workhours.getByCompany}`)).data;
        if (response && response.status==200){

            if(Number(response.result.bankNumber)){
                payload.data.bankNumber = Number(response.result.bankNumber);
                payload.data.bankAgency = response.result.bankAgency;
                payload.data.bankAccountVerificationCode = response.result.bankAccountVerificationCode;
                payload.data.bankAgencyVerificationCode = response.result.bankAgencyVerificationCode;
                payload.data.bankAccountNumber = response.result.bankAccountNumber;
                payload.data.bankDocumentType = response.result.bankDocumentType;
                payload.data.bankDocument = response.result.bankDocument;
                payload.data.bankAccountType = response.result.bankAccountType;
                payload.data.bankNameOwner = response.result.bankNameOwner;
            }

            if(Number(response.result.maxInstalments)){
                payload.data.maxInstalments = Number(response.result.maxInstalments);
               
            }

            payload.data.paymentMethods = response.result.paymentMethods;
            payload.data.isExternalMeet = response.result.isExternalMeet;
            payload.data.monStart = response.result.monStart;
            payload.data.monEnd = response.result.monEnd;
            payload.data.tueStart = response.result.tueStart;
            payload.data.tueEnd = response.result.tueEnd;
            payload.data.wedStart = response.result.wedStart;
            payload.data.wedEnd = response.result.wedEnd;
            payload.data.thuStart = response.result.thuStart;
            payload.data.thuEnd = response.result.thuEnd;
            payload.data.friStart = response.result.friStart;
            payload.data.friEnd = response.result.friEnd;
            payload.data.satStart = response.result.satStart;
            payload.data.satEnd = response.result.satEnd;
            payload.data.sunStart = response.result.sunStart;
            payload.data.sunEnd = response.result.sunEnd;

        }

        // $('#spinner').modal('toggle');
    },
    methods:{
        save: function(){
            $('#spinner').modal('toggle');
            this.errors = [];
            this.messageIdToast = null;
            let state = this;

            this.data.company = this.$session.get('user').companyUser.company._id;

            if ((this.data.bankDocumentType == 'cnpj' && !Common.isValidCNPJ(this.data.bankDocument)) ||
                this.data.bankDocumentType == 'cpf' && !Common.isValidCPF(this.data.bankDocument)){

                $('#spinner').modal('toggle');
                this.titleToast = this.$t("string.msg.warning");
                this.messageToast = this.$t('string.msg.bank.invalid.document');
                $('#toast').modal('show');

                return;
            }

            Request.do(this, 'POST', Request.getDefaultHeader(this), this.data, `${Endpoints.companies.workhours.post}`,
                (companyResponse)=>{//SUCCESS CALLBACK
                    $('#spinner').modal('toggle');
                    this.flashMessage.success(
                        this.configMessage(this.$t('string.msg.workHours.register.title.success'), this.$t('string.msg.workHours.register.message.success'),'top left', 3000),
                        {
                            mounted: this.showText(this.$t('string.msg.workHours.register.message.success')),
                            destroyed: this.clearText()
                        })
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                        $('#toast').modal('show');
                    }
            });
        },
        getCNPJ: function(){
            this.data.bankDocument =  this.$session.get('user').companyUser.company.document;
        },
        getSocialName: function(){
            this.data.bankNameOwner =  this.$session.get('user').companyUser.company.socialName;
        },
        hasType: function(type){
            if (this.user){
                return this.user.serviceTypes.findIndex(x => x == type) > -1;
            }else{
                return false;
            }
        },
        acceptedTermGeneral: function(resp){
            if (resp==1){
                Request.do(this, 'PUT', Request.getDefaultHeader(this), {isAcceptGeneralTerms:true}, `${Endpoints.systemUsers.updateTerms}${this.user.email}`,
                (response)=>{//SUCCESS CALLBACK
                     if(this.user.isAcceptPurchaseTerms == false)
                    {
                        let service = this.user.serviceTypes[0];
                        if(service == "PART_SUPPLIER")
                        {
                            $('#modalTermParts').modal('toggle'); 
                        }
                        if(service == "CERTIFIER")
                        {
                            $('#modalTermCertifies').modal('toggle'); 
                        }
                        if(service == "SERVICE_PROVIDER")
                        {
                            $('#modalTermServices').modal('toggle'); 
                        }
            
                    }
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }

                    }
                    console.log(JSON.stringify(error));
            });

            }
            else{
                  this.$router.push({ path: '/logout' });
            }
        },
        acceptedTermPurchase: function(response){
            if (response==1){
                Request.do(this, 'PUT', Request.getDefaultHeader(this), {isAcceptPurchaseTerms: true},  `${Endpoints.systemUsers.updateTerms}${this.user.email}`,
                 (companyResponse)=>{//SUCCESS CALLBACK
                },
                (error)=>{//ERROR CALLBACK
                    $('#spinner').modal('toggle');
                    let res = error.response;
                    if (res && res.status){
                        this.titleToast = this.$t("string.msg.warning");
                        if (res.data.messageId === 'response.msg.error.empty.fields'){
                            let fields = "";
                            res.data.errors.forEach(function (value) {
                                fields += state.$t(value.id)+";<br/>";
                            });
                            this.titleToast = this.$t(res.data.messageId);
                            this.messageToast = this.$t(fields);
                        }else if (res.data.messageId === 'response.already.exists'){
                            this.messageToast = this.$t('response.company.already.exists');
                        }else{
                            this.messageToast = this.$t(res.data.messageId);
                            this.messageIdToast = res.data.messageId;
                        }
                    }
                    console.log(JSON.stringify(error));
            });

            }
            else{
                this.$router.push({ path: '/logout' });
            }
        },
        showText(text) {
            this.text = text
        },
        clearText() {
            setTimeout( () => this.text = '', 500);
        },
        configMessage :function(title, message, position, time){
            const config ={
               title: title,
                message: message,
                position: position,
                x: window.innerWidth /60,
                y: window.innerHeight /1.3,
                time: time,
            }
            return config
        },
          
        camelize: Common.toUpperCase,
    }
}
</script>
